/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authenticatorsCreateAuthenticatorConnection } from "../../funcs/authenticatorsCreateAuthenticatorConnection.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateAuthenticatorConnectionRequest$inboundSchema,
};

export const tool$authenticatorsCreateAuthenticatorConnection: ToolDefinition<
  typeof args
> = {
  name: "authenticators-create-authenticator-connection",
  description: `Create Authenticator Connection

Create a connector for a given authenticator. This requires credentials dependent on the provider. For google drive it is a refresh token.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authenticatorsCreateAuthenticatorConnection(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
